// Restore the account key from its recovery file when this browser's storage was lost.
import { UploadSimple } from "@phosphor-icons/react";
import { type FormEvent, useState } from "react";

import { useT } from "../i18n";
import { PanelInput, PanelSecondary } from "./AccountPanel";
import { restoreAccountKey } from "./setup";

interface Props {
  onDone: () => void;
  onError: (message: string) => void;
}

export function RestoreAccountKey({ onDone, onError }: Props) {
  const t = useT().account.restore;
  const [file, setFile] = useState<File>();
  const [passphrase, setPassphrase] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!file) return;
    setBusy(true);
    try {
      await restoreAccountKey(await file.text(), passphrase);
      setPassphrase("");
      onDone();
    } catch (err) {
      onError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="mt-6" aria-label={t.label} onSubmit={(e) => void onSubmit(e)}>
      <div className="text-[13px]">{t.lead}</div>
      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        <PanelInput label={t.file} type="file" accept="application/json,.json" onChange={(e) => setFile(e.target.files?.[0])} />
        <PanelInput
          label={t.passphrase}
          type="password"
          autoComplete="current-password"
          value={passphrase}
          onChange={(e) => setPassphrase(e.target.value)}
        />
      </div>
      <PanelSecondary type="submit" className="mt-4 gap-1.5" disabled={busy || !file || !passphrase}>
        <UploadSimple weight="bold" className="h-4 w-4" /> {busy ? t.restoring : t.submit}
      </PanelSecondary>
    </form>
  );
}
